import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, UserCircle, MessageCircle, DollarSign } from "lucide-react";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const navItems = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/" },
  { label: "Contatos", icon: UserCircle, path: "/contacts" },
  { label: "Mensagens", icon: MessageCircle, path: "/whatsapp" },
  { label: "Negociações", icon: DollarSign, path: "/deals" },
];

export function MobileBottomNav() {
  const location = useLocation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  if (!mounted) return null;

  return createPortal((
    <nav
      className="fixed inset-x-0 bottom-0 z-50 md:hidden border-t border-border bg-background/95 backdrop-blur-sm supports-[backdrop-filter]:bg-background/80 h-[var(--bottom-nav-total-height)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="flex items-center justify-around h-[var(--bottom-nav-height)]">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors",
                active
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <item.icon
                className={cn(
                  "h-5 w-5",
                  active && "fill-primary/20"
                )}
              />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  ), document.body);
}
